import React from 'react';
import config from 'trade-in/config/index.js';
import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';

const InstantEstimateIcon = () => {
    const imagesServer = config.source.image;
    const czGroup = 'widget.tradein.teaser';
    const estimateIcon = ContentZonesService.getContentZone(czGroup, 'icon')
        ? ContentZonesService.getContentZone(czGroup, 'icon').getValue()
        : `${imagesServer}/images/widget/showroom/asset/estimate-value-teaser.png`;
    const estimateBackground = ContentZonesService.getContentZone(czGroup, 'icon.background.color')
        ? ContentZonesService.getContentZone(czGroup, 'icon.background.color').getValue()
        : '#B01925';
    const backgroundColor = {
        backgroundColor: estimateBackground,
    };
    return (
        <div className="instant-estimate__image-section" style={backgroundColor}>
            <img src={estimateIcon} alt={LocaleService.t('TRADE_IN.TEASER.INSTANT_ESTIMATE')} />
        </div>
    );
};

InstantEstimateIcon.propTypes = {};

InstantEstimateIcon.displayName = 'InstantEstimateIcon';

export default InstantEstimateIcon;
